import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

// Module-scoped state (not per-hook): there is only ever one socket connection/listener
// registration for the app's lifetime, so a module-level queue is equivalent to the god-class's
// original instance fields (`this.roomUsersEvent`/`this.timeOutRoomEvent`).
const roomUsersEvent: any[] = [];
let timeOutRoomEvent: ReturnType<typeof setTimeout> | undefined;

const roomPresenceRealtimeListeners: SocketEventListener[] = [
  {
    event: 'roomUsers',
    handler: (msg: any) => {
      // console.log('socket io - roomUsersListener', msg);
      if (msg.roomType === 'Event') {
        roomUsersEvent.push(msg);
      }
      if (!timeOutRoomEvent) {
        timeOutRoomEvent = setTimeout(() => {
          if (roomUsersEvent.length > 0) {
            emitter.emit(
              EMITTER_CONSTANTS.EVENT_ROOM_USER,
              roomUsersEvent.splice(0, roomUsersEvent.length),
            );
          }
          timeOutRoomEvent = undefined;
        }, 1000);
      }
    },
  },
];

/**
 * Discards the buffered room-presence events awaiting their debounce window. Clears the pending timeout, forgets its handle and truncates the queued room-user events.
 *
 * @returns Nothing.
 */
export const resetRoomPresenceQueue = () => {
  clearTimeout(timeOutRoomEvent);
  timeOutRoomEvent = undefined;
  roomUsersEvent.length = 0;
};

export default roomPresenceRealtimeListeners;
